import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import Text from '@dbk/ui-text';
import { Percent } from '../../../common/number';
import { NO_DATA } from '../../../../constants';
import truncateText from '../../../../utils/truncate-text';

//import Device from 'react-native-device-detection';
const Device = require('react-native-device-detection');
import styles from './asset-item-header.styles';

class AssetItemCurrencyData extends PureComponent {
  static propTypes = {
    row: PropTypes.shape({
      description: PropTypes.oneOfType([
        { name: PropTypes.string },
        PropTypes.string,
      ]),
      subDescription: PropTypes.number,
    }),
    shorten: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number,
    ]),
  };

  static defaultProps = {
    row: {},
    shorten: false,
  };

  renderSubDescription(subDescription) {
    if (!subDescription) {
      return null;
    }

    return (
      <Percent
        value={subDescription}
        onlyNegativeStyling
      >
        {
          (text, props) =>
            <Text style={styles.subDescription} {...props}>
              ({text})
            </Text>
        }
      </Percent>
    );
  }

  render() {
    const { row } = this.props;
    const {
      description,
      subDescription,
    } = row;

    const fullTitle = typeof description === 'string' || description == null ?
      description : description.name;
    const truncatedChars = Number.isInteger(this.props.shorten) ? this.props.shorten : 80;
    const truncatedCharsTablet = 50;
    const title = this.props.shorten && fullTitle
      ? truncateText(description.name || description, truncatedChars)
      : fullTitle || NO_DATA;
    const titleTablet = this.props.shorten && fullTitle
      ? truncateText(description.name || description, truncatedCharsTablet)
      : fullTitle || NO_DATA;

    return (
      <View style={styles.description}>
        <Text
          numberOfLines={1}
          style={[
            styles.headerCurrency,
            (fullTitle ? null : styles.headerDisabled),
          ]}
        >{Device.isTablet ? titleTablet : title}&nbsp;</Text>
        {this.renderSubDescription(subDescription)}
      </View>
    );
  }
}

export default AssetItemCurrencyData;
